import { useEffect, useRef, useState } from "react";
import MenuLayout from "../../layouts/MenuLayout";
import { useNavigate } from "react-router-dom";
import { coachPaths } from "../../routes/coach";
import { useDispatch, useSelector } from "react-redux";
import { fetchCoachList } from "../../redux/features/coach/actions/coachAction";
import Loader from "../../components/loader";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";

const Community = () => {
  const user = { name: "founder-coaching", role: "coach" };
  const { isLoading2, coachList } = useSelector((state) => state.coach.coach);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  //   const [navBarDemo, setNavBarDemo] = useState("Founder");

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    dispatch(fetchCoachList());
  }, []);

  const displayUsers = coachList?.filter((item) => {
    const matchCoachingType = item?.category_name
      ?.toLowerCase()
      .includes("founder");
    return matchCoachingType;
  });

  if (isLoading2) {
    return <Loader />;
  }

  return (
    <MenuLayout user={user}>
      <>
        <section class="ct_px_40    py-5">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div
                class="col-md-12  mb-4 mb-md-0 "
                data-aos="fade-down"
                data-aos-duration="1500"
              >
                <div class="ct_px_40 ct_px_0_767 text-center">
                  <h2
                    class="ct_fs_50_new mb-4 mx-auto "
                    style={{ maxWidth: "831px" }}
                  >
                    Expand your reach, elevate your
                    <span class="ct_yellow_text"> impact </span>, and own your
                    next move.
                  </h2>
                  <p
                    class="mb-0 mt-3 ct_fs_20 mx-auto"
                    style={{ maxWidth: "800px" }}
                  >
                    NUVIO Community bridges the gap between ambition and action.
                    Whether you’re a freelancer, founder, or coach, it’s where
                    you connect, learn, and grow together.
                  </p>
                  <div class="ct_mt_30 d-flex align-items-center justify-content-center gap-4 ct_flex_col_575">
                    <a class="ct_yellow_btn ct_sky_light_btn_new  px-5 ct_fit_content ct_h_48 ct_w_100_575">
                      Explore
                    </a>

                    <a class="ct_yellow_btn ct_light_outline_btn  px-5 ct_fit_content ct_h_48 ct_w_100_575">
                      Get Started
                    </a>
                  </div>
                </div>

                <div className="row ct_mt_30">
                  <div className="col-sm-6 mb-4">
                    <div className="ct_aspect_ratio_for_486_res">
                      <img
                        src="../assets/img/community_single_img_1.png"
                        className="ct_img_h_486"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 mb-4">
                    <div className="ct_aspect_ratio_for_486_res">
                      <img
                        src="../assets/img/community_single_img_2.png"
                        className="ct_img_h_486"
                      />
                    </div>
                  </div>
                </div>

                <ul className="ct_freelance_banner_count ct_flex_col_575">
                  <li className="d-flex align-items-center gap-3 flex-wrap ">
                    <span className="ct_fs_48 ct_white_nowrap">1M+</span>
                    <span className="ct_fs_17" style={{ maxWidth: "187px" }}>
                      Customers visit Nuvio every months
                    </span>
                  </li>
                  <li className="d-flex align-items-center gap-3 flex-wrap">
                    <span className="ct_fs_48 ct_white_nowrap">93%</span>
                    <span className="ct_fs_17" style={{ maxWidth: "187px" }}>
                      Satisfaction rate from our customers.
                    </span>
                  </li>
                  <li className="d-flex align-items-center gap-3 flex-wrap">
                    <span className="ct_fs_48 ct_white_nowrap">4.9</span>
                    <span className="ct_fs_17" style={{ maxWidth: "187px" }}>
                      Average customer ratings out of 5.00!
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <div className="ct_border_top_light ">
          <section className="ct_dark_blue_bg rounded-0 ct_mt_20 ct_py ct_search_dream_job_main">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="pt-4">
                    <div className="d-flex align-items-center gap-3 justify-content-between ct_mb_40 ct_flex_col_575">
                      <h4 className="ct_fs_32 mb-0 text-white">
                        NUVIO Community
                      </h4>
                      <a className="ct_yellow_btn ct_sky_blue_btn ct_border_radius_8 ct_h_50 ct_white_nowrap">
                        View events
                      </a>
                    </div>

                    <div className="row">
                      <div className="col-lg-9 mx-auto">
                        <div className="row gx-xl-5">
                          <div
                            className="col-xl-4 col-lg-4 col-md-6 mb-4 mb-lg-0"
                            data-aos="fade-down"
                            data-aos-duration="1500"
                          >
                            <div
                              className="ct_opportunity_card text-center"
                              style={{ backgroundColor: "#219EBC" }}
                            >
                              <img
                                src="../assets/img/coach_talk_icon.png"
                                width="45px"
                                height="45px"
                                className="mx-auto d-block ct_object_fit"
                              />
                              <div className="mt-3">
                                <h4 className="ct_fs_24_new text-white mb-3">
                                  Coach Talks
                                </h4>
                                <a className="ct_light_blue_link">
                                  View All{" "}
                                  <i class="fa-solid fa-arrow-right ms-2"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-xl-4 col-lg-4 col-md-6 mb-4 mb-lg-0"
                            data-aos="fade-down"
                            data-aos-duration="1500"
                          >
                            <div
                              className="ct_opportunity_card text-center"
                              style={{ backgroundColor: "#FFB703" }}
                            >
                              <img
                                src="../assets/img/cross_group_icon.png"
                                className="mx-auto d-block ct_object_fit"
                              />
                              <div className="mt-0">
                                <h4 className="ct_fs_24_new text-white mb-3">
                                  Cross Group
                                </h4>
                                <a className="ct_light_blue_link">
                                  View All{" "}
                                  <i class="fa-solid fa-arrow-right ms-2"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-xl-4 col-lg-4 col-md-6 mb-4 mb-lg-0"
                            data-aos="fade-down"
                            data-aos-duration="1500"
                          >
                            <div
                              className="ct_opportunity_card text-center"
                              style={{ backgroundColor: "#FB8500" }}
                            >
                              <img
                                src="../assets/img/skill_lab_icon.png"
                                width="45px"
                                height="45px"
                                className="mx-auto d-block ct_object_fit"
                              />
                              <div className="mt-3">
                                <h4 className="ct_fs_24_new text-white mb-3">
                                  Skill Lab
                                </h4>
                                <a className="ct_light_blue_link">
                                  View All{" "}
                                  <i class="fa-solid fa-arrow-right ms-2"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className="ct_px_40 ct_py_55 "
            style={{ backgroundColor: "#219EBC" }}
          >
            <div className="container-fluid">
              <div className="row align-items-end">
                <div
                  className="col-xxl-4 col-xl-4 mb-4 mb-xl-0 "
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div className="">
                    <h4 className="ct_fs_32 mb-2 text-white text-center text-xl-start">
                      Google Ads Goes Here
                    </h4>
                    <p
                      className="ct_fs_18 text-white mb-0 mx-auto mx-xl-0"
                      style={{ maxWidth: "341px" }}
                    >
                      Start your journey with our top free companies with your
                      personal branding in check
                    </p>
                    <div className="ct_mt_30 ">
                      <button className="ct_yellow_btn ct_darkblue_btn px-5 mx-auto mx-xl-0">
                        Learn More
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  className="col-xxl-8 col-xl-8 mb-4 mb-xl-0"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div className="d-flex align-items-center justify-lg-content-end justify-content-center gap-3 ga-md-5">
                    <div className="px-3">
                      <img
                        src="../assets/img/google_ads_1.png"
                        className="w-100"
                      />
                    </div>
                    <div className="px-3">
                      <img
                        src="../assets/img/google_ads_2.png"
                        className="w-100"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class=" ct_px_40 ct_pt_65_pb_85">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="ct_how_work_img">
                    <img
                      src="../assets/img/coach_talk_left_img.png"
                      alt=""
                      style={{ objectFit: "cover", objectPosition: "right" }}
                    />
                  </div>
                </div>
                <div
                  class="col-lg-8 mb-4 mb-lg-0 aos-init aos-animate ps-lg-5"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div class="ct_how_work_content">
                    <h4 class="ct_fs_35 ct_yellow_text">Coach Talk </h4>

                    <h3 class="ct_fs_32 ct_darksky_blue_text ">
                      What You’ll Find: Real Conversations. Real Growth.
                    </h3>
                  </div>
                  <div class="row mt-5 pt-4">
                    <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/search_orange_icon_4567.png"
                          alt=""
                          className="ct_w_50_330"
                        />
                        <div class="pt-5">
                          <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                            Hire Smarter, Faster
                          </h5>
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "188px" }}
                          >
                            Negotiation: Communicate with confidence and impact.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/fa6-solid_handshake_orange.png"
                          alt=""
                          className="ct_w_50_340"
                        />
                        <div class="pt-5">
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "196px" }}
                          >
                            Leadership: Lead yourself and others with clarity.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/bxs_trophy_456.png"
                          alt=""
                          className="ct_w_50_330"
                        />
                        <div class="pt-5">
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "189px" }}
                          >
                            Productivity: Build habits that turn goals into
                            results.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class=" ct_px_40 ">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-lg-8 mb-4 mb-lg-0  "
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="ct_how_work_content">
                    <h4 class="ct_fs_35 ct_yellow_text">Cross Group </h4>
                    <h3 class="ct_fs_32 ct_darksky_blue_text ">
                      Because growth happens faster when you connect.
                    </h3>
                  </div>
                  <div class="row mt-5 pt-4">
                    <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/search_orange_icon_4567.png"
                          alt=""
                          className="ct_w_50_330"
                        />
                        <div class="pt-5">
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "188px" }}
                          >
                            “Founder Meets Coach” / “Freelancer x Founder
                            Connect” — monthly networking events designed for
                            meaningful, time-efficient conversations.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/fa6-solid_handshake_orange.png"
                          alt=""
                          className="ct_w_50_340"
                        />
                        <div class="pt-5">
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "192px" }}
                          >
                            Pitch & Collaboration Sessions — where founders
                            present startup ideas, gain feedback from coaches,
                            and even connect with investors.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/bxs_trophy_456.png"
                          alt=""
                          className="ct_w_50_330"
                        />
                        <div class="pt-5">
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "198px" }}
                          >
                            Funding Readiness Coaching — exclusive small-group
                            workshops run by strategy and business experts.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-lg-4 mb-4 mb-lg-0 ps-lg-5"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div class="ct_how_work_img ct_how_work_imgaspext_991">
                    <img
                      src="../assets/img/cross_group_img_right_456.png"
                      alt=""
                      style={{ objectFit: "cover", objectPosition: "right" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            data-aos="fade-right"
            data-aos-duration="1500"
            class="ct_looking_for_work_bg ct_looking_for_work_bg_left     ct_p_111_y_106 ct_mt_100"
            style={{ backgroundColor: "#8ECAE6" }}
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4 class="ct_fs_36 mb-4 ct_orange_text">
                  Join a space built to evolve with you
                </h4>
                <p class="mb-0 ct_fs_18 ct_fw_300">
                  A community shaped by your feedback, ready to support your
                  growth, connections, and impact.
                </p>
              </div>
              <div class="ct_flex_shrink_0">
                <a
                  class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                // onClick={() => navigate(coachPaths?.ContactUs)}
                >
                  Join Community
                </a>
              </div>
            </div>
          </section>

          <section class=" ct_px_40 ct_pt_65_pb_85">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="ct_how_work_img">
                    <img
                      src="../assets/img/skill_lsb_img_left.png"
                      alt=""
                      style={{ objectFit: "cover", objectPosition: "right" }}
                    />
                  </div>
                </div>
                <div
                  class="col-lg-8 mb-4 mb-lg-0 aos-init aos-animate ps-lg-5"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div class="ct_how_work_content">
                    <h4 class="ct_fs_35 ct_yellow_text">Skill lab </h4>

                    <h3 class="ct_fs_32 ct_darksky_blue_text ">
                      Masterclasses that Move You Forward
                    </h3>
                  </div>
                  <div class="row mt-5 pt-4">
                    <div class="col-lg-4">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/search_orange_icon_4567.png"
                          alt=""
                          className="ct_w_50_330"
                        />
                        <div class="pt-4">
                          <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                            Hire Smarter, Faster
                          </h5>
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "188px" }}
                          >
                            Negotiation: Communicate with confidence and impact.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/fa6-solid_handshake_orange.png"
                          alt=""
                          className="ct_w_50_340"
                        />
                        <div class="pt-4">
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "196px" }}
                          >
                            Leadership: Lead yourself and others with clarity.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <div class="ct_how_work_card">
                        <img
                          src="../assets/img/bxs_trophy_456.png"
                          alt=""
                          className="ct_w_50_330"
                        />
                        <div class="pt-4">
                          <p
                            class="mb-0 ct_fs_16"
                            style={{ maxWidth: "189px" }}
                          >
                            Productivity: Build habits that turn goals into
                            results.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            class="ct_pt_65_pb_58 ct_px_40"
            style={{ backgroundColor: "hsl(199deg 64% 73% / 20%)" }}
          >
            <div class="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <h4 class="ct_fs_40 ct_darkblue_text mb-0 text-center">
                    Why Join the NUVIO Community
                  </h4>
                  <p
                    className="ct_mt_60 mb-0 ct_fs_24_new"
                    style={{ maxWidth: "1200px" }}
                  >
                    The NUVIO Community is more than a network, it’s your growth
                    accelerator. Here, you gain access, direction, and
                    opportunities that move your career or business forward with
                    purpose.
                  </p>
                </div>
              </div>
              <div class="row pt-5 align-items-center">
                <div
                  class="col-lg-6 mb-4 mb-lg-0 "
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <ul className="">
                    <li>
                      <h4 className="ct_fs_28_new mb-2 ct_orange_text">
                        Build Meaningful Connections
                      </h4>
                      <p
                        className="mb-0 ct_fs_22 ct_darkblue_text"
                        style={{ maxWidth: "578px" }}
                      >
                        Join a curated network of founders, freelancers, and
                        coaches who share your drive to grow. Collaborate,
                        exchange insights, and create partnerships that open
                        real doors.
                      </p>
                    </li>
                    <li className="mt-5">
                      <h4 className="ct_fs_28_new mb-2 ct_orange_text">
                        Learn from Proven Experts
                      </h4>
                      <p
                        className="mb-0 ct_fs_22 ct_darkblue_text"
                        style={{ maxWidth: "578px" }}
                      >
                        Gain direct access to seasoned coaches and industry
                        leaders through live sessions, Q&As, and masterclasses
                        designed to sharpen your mindset and skill set.
                      </p>
                    </li>
                    <li className="mt-5">
                      <h4 className="ct_fs_28_new mb-2 ct_orange_text">
                        Turn Insight into Action
                      </h4>
                      <p
                        className="mb-0 ct_fs_22 ct_darkblue_text"
                        style={{ maxWidth: "578px" }}
                      >
                        Every conversation, tool, and session is designed to
                        help you apply what you learn transforming strategies
                        into visible results and consistent progress.
                      </p>
                    </li>
                    <li className="mt-5">
                      <h4 className="ct_fs_28_new mb-2 ct_orange_text">
                        Grow with Clarity and Confidence
                      </h4>
                      <p
                        className="mb-0 ct_fs_22 ct_darkblue_text"
                        style={{ maxWidth: "578px" }}
                      >
                        Define your goals, position your expertise, and build
                        momentum with guidance that keeps you accountable and
                        inspired.
                      </p>
                    </li>
                  </ul>
                </div>
                <div
                  class="col-lg-6 mb-4 mb-lg-0 ps-lg-5"
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div>
                    <img
                      src="assets/img/community_join_right_img.png"
                      className="ct_img_h_668"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            className="ct_px_40 ct_pt_100 pb-0"
            data-aos="fade-down"
            data-aos-duration="1500"
          >
            <div className="container-fluid">
              {/* convert into slider */}
              <div className="row">
                <div className="col-lg-4 col-md-6 mb-4">
                  <div class="ct_testimonial_review_card h-100 d-grid">
                    <div>
                      <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                        <div class="d-flex align-items-center gap-1">
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        </div>
                        <p className="mb-0 ct_fs_16">20th April, 2025</p>
                      </div>
                      <p className="mb-0 " style={{ maxWidth: "295px" }}>
                        The expert sessions and networking inside NuForge are next level. I finally feel part of a serious community that pushes me to grow.
                      </p>
                    </div>
                    <div className="mt-auto">
                      <div class="d-flex align-items-center gap-3 ct_mt_40">
                        <img
                          src="/assets/img/Ellipse 24.png"
                          class="ct_img_60 "
                          alt=""
                        />
                        <div>
                          <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                            Alex Robertson
                          </h5>
                          <p class="mb-0  ct_fs_16  ">Frontend Developer</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 mb-4">
                  <div class="ct_testimonial_review_card h-100 d-grid">
                    <div>
                      <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                        <div class="d-flex align-items-center gap-1">
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        </div>

                        <p className="mb-0 ct_fs_16">20th April, 2025</p>
                      </div>
                      <p className="mb-0 " style={{ maxWidth: "295px" }}>
                        With NuForge, I refined my services, rebranded my profile, and doubled my client reach in just a few weeks. Totally worth it!
                      </p>
                    </div>
                    <div className="mt-auto">
                      <div class="d-flex align-items-center gap-3 ct_mt_40">
                        <img
                          src="/assets/img/Ellipse 24 (1).png"
                          class="ct_img_60 "
                          alt=""
                        />
                        <div>
                          <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                            Olivia Brooks
                          </h5>
                          <p class="mb-0  ct_fs_16  ">Mobile App Developer</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 mb-4">
                  <div class="ct_testimonial_review_card h-100 d-grid">
                    <div>
                      <div className="d-flex align-items-center gap-3 mb-3 justify-content-between">
                        <div class="d-flex align-items-center gap-1">
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                          <i class="fa-solid fa-star ct_orange_text ct_fs_16"></i>
                        </div>

                        <p className="mb-0 ct_fs_16">20th April, 2025</p>
                      </div>
                      <p className="mb-0 " style={{ maxWidth: "295px" }}>
                        NuForge helped me position myself for higher-paying clients by improving my portfolio and strategy.
                      </p>
                    </div>
                    <div className="mt-auto">
                      <div class="d-flex align-items-center gap-3 ct_mt_40">
                        <img
                          src="/assets/img/Ellipse 24 (2).png"
                          class="ct_img_60 "
                          alt=""
                        />
                        <div>
                          <h5 class="ct_fs_18  mb-1 me-1 ct_grey_text">
                            James Thornton
                          </h5>
                          <p class="mb-0  ct_fs_16  ">Cloud Solutions Architect</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section
            data-aos="fade-left"
            data-aos-duration="1500"
            class="ct_looking_for_work_bg  mt-5    ct_p_111_y_106 "
            style={{ backgroundColor: "#FFB703" }}
          >
            <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
              <div class="text-white">
                <h4 class="ct_fs_36 mb-4">Unlock your growth</h4>
                <p
                  class="mb-0 ct_fs_18 ct_fw_300"
                  style={{ maxWidth: "600px" }}
                >
                  Learn directly from experienced coaches who turn insight into
                  impact — guiding you to grow with clarity, confidence, and
                  purpose.
                </p>
              </div>
              <div class="ct_flex_shrink_0">
                <a class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5">
                  View Coaches
                </a>
              </div>
            </div>
          </section>

          <section class=" ct_px_40 pt-0 ct_mt_100 ct_mb_100">
            <div class="container-fluid">
              <div class="row align-items-center">
                <div
                  class="col-xxl-7 col-xl-7 col-md-6 mb-4 mb-md-0 "
                  data-aos="fade-right"
                  data-aos-duration="1500"
                >
                  <div class="ct_about_cnt">
                    <h2 class=" ct_fs_32  ct_mb_60">
                      Frequently asked questions
                    </h2>

                    <div class="ct_faq_question_main ct_faq_question_yellow_plus">
                      <div class="accordion" id="faq_accordionExample">
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faq_one">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_one"
                              aria-expanded="false"
                              aria-controls="collapsefaq_one"
                            >
                              How do I get started as a freelancer on NUVIO?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_one"
                            class="accordion-collapse collapse"
                            aria-labelledby="faq_one"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                Simply sign up for an account, create your
                                profile highlighting your skills and experience,
                                and start browsing or applying for projects that
                                interest you.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faqtwo">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_Two"
                              aria-expanded="true"
                              aria-controls="collapseTwo"
                            >
                              What types of projects can I find on NUVIO?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_Two"
                            class="accordion-collapse collapse "
                            aria-labelledby="faqtwo"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                Simply sign up for an account, create your
                                profile highlighting your skills and experience,
                                and start browsing or applying for projects that
                                interest you.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faqthree">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_Three"
                              aria-expanded="false"
                              aria-controls="collapsefaq_Three"
                            >
                              How does payment work?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_Three"
                            class="accordion-collapse collapse"
                            aria-labelledby="faqthree"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                Simply sign up for an account, create your
                                profile highlighting your skills and experience,
                                and start browsing or applying for projects that
                                interest you.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="accordion-item">
                          <h2 class="accordion-header" id="faqFour">
                            <button
                              class="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapsefaq_Four"
                              aria-expanded="false"
                              aria-controls="collapsefaq_Four"
                            >
                              What support does NUVIO provide to freelancers?
                            </button>
                          </h2>
                          <div
                            id="collapsefaq_Four"
                            class="accordion-collapse collapse"
                            aria-labelledby="faqFour"
                            data-bs-parent="#faq_accordionExample"
                          >
                            <div class="accordion-body">
                              <p class="ct_fs_20 mb-0 ct_line_h_30">
                                Simply sign up for an account, create your
                                profile highlighting your skills and experience,
                                and start browsing or applying for projects that
                                interest you.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="col-xxl-4  col-xl-5 col-md-6 mb-4 mb-md-0 ps-xl-5 "
                  data-aos="fade-left"
                  data-aos-duration="1500"
                >
                  <div class="ct_about_img">
                    <img
                      src="../assets/img/pexels-fauxels_456.png"
                      class="ct_img_h_617"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    </MenuLayout>
  );
}

export default Community